export enum EScheduleQueryKeys {
  getScheduleLessons = "getScheduleLessons",
}

export const SCHEDULE_ENDPOINTS = {
  SCHEDULE: "/schedule",
};
